<template>
  <el-dialog :title="editFormTitle" :visible.sync="visible" width="600px" center>
    <el-form :model="editForm">
      <el-form-item label="优惠次数" :label-width="formLabelWidth">
        <el-input v-model="editForm.discount_num" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="单次优惠金额" :label-width="formLabelWidth">
        <el-input v-model="editForm.discount" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="数量" :label-width="formLabelWidth">
        <el-input v-model="editForm.num" autocomplete="off" placeholder="请输入优惠券数量（不大于999）"></el-input>
      </el-form-item>
      <el-form-item label="     " :label-width="formLabelWidth">
        注：取消订单不返还优惠券。
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { isEmpty } from '@/utils'
import { auditOrderCancelById, addCoupon } from '../../../api'

export default {
  name: 'EditDiscount',
  data() {
    return {
      id: null,
      editForm: {
        discount_num: '',
        discount: '',
        num: ''
      },
      formLabelWidth: '153px',
      visible: false
    }
  },
  computed: {
    editFormTitle() {
      return isEmpty(this.id) ? '编辑优惠券' : '新增优惠券'
    }
  },
  methods: {
    async handleOpen(val) {
      let defaultFrom = {
        discount_num: '',
        discount: '',
        num: ''
      }
      this.id = null
      if (!isEmpty(val)) {
        defaultFrom = val
        this.id = val.id
      }
      this.editForm = defaultFrom
      this.visible = true
    },
    handleSubmit() {
      const { id } = this
      const {
        discount_num,
        discount,
        num } = this.editForm
      let c = addCoupon

      if (isEmpty(discount_num)) return this.$message({ message: '请输入优惠次数！', type: 'warning' })
      if (isEmpty(discount)) return this.$message({ message: '请输入单次优惠金额！', type: 'warning' })
      if (isEmpty(num) || num > 999) return this.$message({ message: '请输入优惠券数量（不大于999）！', type: 'warning' })

      const params = {
        discount_num,
        discount,
        num,
        username: sessionStorage.getItem('username')
      }
      if (id) {
        params.id = id
        c = auditOrderCancelById
      }
      c(params).then(res => {
        if (res.status) {
          this.$message.success(res.msg)
          this.handleClose()
          this.$emit('update')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleClose() {
      this.visible = false
    },
  }
}
</script>

<style scoped>

</style>
